import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter } from "react-router-dom";
import { PortalContainerProvider } from "@/context/PortalContainerContext";
import { getAppComponent } from "@/registry";
var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            refetchOnWindowFocus: false,
        },
    },
});
document.addEventListener("DOMContentLoaded", function () {
    // Find all elements with data-harmony-app attribute
    var containers = document.querySelectorAll("[data-harmony-app]");
    containers.forEach(function (container) {
        var appType = container.getAttribute("data-harmony-app");
        if (!appType) {
            console.warn("Harmony: Container found without app type", container);
            return;
        }
        var AppComponent = getAppComponent(appType);
        if (!AppComponent) {
            console.warn("Harmony: No component registered for app type \"".concat(appType, "\""), container);
            return;
        }
        var root = createRoot(container);
        root.render(React.createElement(React.StrictMode, null,
            React.createElement(HashRouter, null,
                React.createElement(QueryClientProvider, { client: queryClient },
                    React.createElement(PortalContainerProvider, null,
                        React.createElement(AppComponent, null))))));
    });
});
